import React from "react";
import "./Experience.css";

const Experience = () => {
  return (
    <div className="experience">
      <div className="achievements">
        <div className="circle">3+</div>
        <span> years</span>
        <span>Experience</span>
      </div>
      <div className="achievements">
        <div className="circle">15+</div>
        <span>projects</span>
        <span>worked on </span>
      </div>
      <div className="achievements">
        <div className="circle"> 6</div>
        <span>companies</span>
        <span>init</span>
      </div>
    </div>
  );
};

export default Experience;
